import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { Line } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import ReactSelect from "react-select";
import { dropdownStyles } from "../../buy/buy";
import yearlyData from "../../prices/tableConvert.com_2p1qty.json";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  zoomPlugin,
  TimeScale,
  Tooltip,
  Legend
);

const LineChartMultiMarkets = () => {
  const [chartData, setChartData] = useState({});
  const [products, setProducts] = useState([]); //The products on the dropdown
  const [selectedProduct, setSelectedProduct] = useState(""); // The currently selected product for which the chart should display its relevant data.
  const [selectedUnit, setselectedUnit] = useState([]);

  // This useEffect sets the unique products for the dropdown and initialize the selectedProduct
  useEffect(() => {
    const uniqueProducts = Array.from(
      new Set(yearlyData.map((item) => item["Product Ar"]))
    );
    // console.log('Unique products:', uniqueProducts); // Debugging line
    if (uniqueProducts.length > 0) {
      setProducts(
        uniqueProducts.map((product) => ({ value: product, label: product }))
      );
      setSelectedProduct(uniqueProducts[0]); // Automatically select the first product
    } else {
      console.log("No products found in data"); // Debugging line
    }
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const filteredData = yearlyData.filter(
        (item) => item["Product Ar"] === selectedProduct
      );
      const unit = filteredData.length > 0 ? filteredData[0].Unit : "No unit";
      setselectedUnit(unit);
      if (filteredData.length > 0) {
        const marketNames = Object.keys(filteredData[0]).slice(5);

        const datasets = marketNames.map((market, index) => ({
          label: market,
          data: filteredData.map((item) => item[market]),
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],

          borderWidth: 1,
          tension: 0.1,
        }));

        const labels = filteredData.map(
          (item) => `${item.Year}-${item.Month.toString().padStart(2, "0")}`
        );

        setChartData({
          labels,
          datasets,
        });
      } else {
        setChartData({ labels: [], datasets: [] });
      }
    }
  }, [selectedProduct]);

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption.value);
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: "time",
        time: {
          unit: "month",
          tooltipFormat: "MMMM yyyy",
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 15,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "line",
          padding: 25,
        },
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          pinch: {
            enabled: true, // Enable pinch zooming
          },
          wheel: {
            enabled: true, // Enable wheel zooming
          },
          mode: "x",
        },
        // set limit for zooming out on the x and y axis
        limits: {
          x: {
            min: "original",
            max: "original",
          },
          y: {
            min: "original",
            max: "original",
          },
        },
      },
      transitions: {
        zoom: {
          animation: {
            duration: 1000,
            easing: "easeOutCubic",
          },
        },
      },
    },
  };

  return (
    <div>
      <div className="justify-center flex-col gap-3 px-3 my-10 lg:flex-row-reverse w-full lg:gap-28 lg:mt-10 lg:mb-9 flex ">
        <ReactSelect
          options={products}
          onChange={handleProductChange}
          value={products.find((product) => product.value === selectedProduct)}
          styles={dropdownStyles}
          closeMenuOnSelect={true}
          isRtl
          placeholder="المنتج"
          className="lg:w-[15rem]"
        />
        <div className="lg:w-[15rem] p-2 flex justify-center items-center border-secondary border rounded-[67px] ">
          {selectedUnit} :الوحدة
        </div>
      </div>

      <div
        className="flex justify-center flex-col border-primary border rounded-xl shadow-lg px-1 lg:px-3 py-9 w-full"
      >
        <div className="justify-center gap-1 flex -mt-4 mb-4">
          <span>في مختلف الأسواق</span>
          <span className="font-bold">{selectedProduct}</span>
          <span> سعر </span>
        </div>

        <div  className="w-full" style={{height: "500px" }}>
          {chartData.datasets && chartData.datasets.length > 0 && (
            <Line data={chartData} options={options} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LineChartMultiMarkets;
